import ExportPrices from "@/store/api/data/ExportPrices";
export default {
    state: {
        exportList: []
    },
    mutations: {
        setExportList(state, exportList) {
            state.exportList = exportList;
        }
    },
    actions: {
        loadExports({ commit }) {
            return ExportPrices.getAll().then(response => {
                commit("setExportList", response.data);
                return response;
            });
        },
        async addToExports({ dispatch }, exportPrices) {
            await ExportPrices.addTo(exportPrices);
            dispatch("loadExports");
        },
        async deleteExport({ dispatch }, save_id) {
            await ExportPrices.delete(save_id);
            dispatch("loadExports");
        }
    }
};
